'use client';

import { cn } from '@workspace/ui/lib';
import { Logo, useSidebar } from '../index';

export function SidebarLogo() {
  const { open } = useSidebar();

  return (
    <div className="relative h-[17px] w-[156px]">
      <Logo
        variant="horizontal"
        color="black"
        className={cn(
          'absolute inset-0 h-[17px] w-[156px] transition-all duration-100 ease-in-out',
          open ? 'opacity-100' : 'opacity-0'
        )}
      />
      <Logo
        variant="symbol"
        color="black"
        className={cn(
          'relative inset-0 h-[17px] w-[17px] transition-all duration-100 ease-in-out',
          open ? 'opacity-0' : 'opacity-100'
        )}
      />
    </div>
  );
}
